var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRemoveImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 13C25 6.09644 19.4036 0.5 12.5 0.5C5.59644 0.5 0 6.09644 0 13C0 19.9036 5.59644 25.5 12.5 25.5C19.4036 25.5 25 19.9036 25 13Z",
    fill: "#181C23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5822 8.06718L12.5063 11.1431L9.43034 8.06718C9.18358 7.82043 8.84892 7.68178 8.49995 7.68178C8.15098 7.68178 7.81629 7.82043 7.56953 8.06718C7.32278 8.31394 7.18416 8.6486 7.18416 8.99757C7.18416 9.34654 7.32278 9.68123 7.56953 9.92799L10.6454 13.0039L7.56953 16.0798C7.32278 16.3266 7.18416 16.6612 7.18416 17.0102C7.18416 17.3592 7.32278 17.6939 7.56953 17.9406C7.81629 18.1874 8.15098 18.326 8.49995 18.326C8.84892 18.326 9.18358 18.1874 9.43034 17.9406L12.5063 14.8647L15.5766 17.935C15.8233 18.1818 16.158 18.3204 16.507 18.3204C16.856 18.3204 17.1906 18.1818 17.4374 17.935C17.6842 17.6883 17.8228 17.3536 17.8228 17.0046C17.8228 16.6557 17.6842 16.321 17.4374 16.0742L14.3671 13.0039L17.443 9.92799C17.6897 9.68123 17.8284 9.34654 17.8284 8.99757C17.8284 8.64861 17.6897 8.31394 17.443 8.06718C17.1962 7.82043 16.8616 7.68178 16.5126 7.68178C16.1636 7.68178 15.8289 7.82043 15.5822 8.06718Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemoveImage);
export default __webpack_public_path__ + "static/media/icon-remove-image.040ad5b3.svg";
export { ForwardRef as ReactComponent };